import { combineReducers } from 'redux';

import tablesGraphSlice from './api/tablesGraphSlice';

export default combineReducers({
    tablesGraph: tablesGraphSlice,
});
